import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import {
  ModalCloseButton,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import Banner from '@/components/ui/banner';
import { TriangleAlert } from 'lucide-react';
import { BANNER_TITLE, DESCRIPTION } from './confirm-unsaved-changes-modal.constant';
import { useConfirmUnsavedChangesModal } from './use-confirm-unsaved-changes-modal';

export interface IConfirmUnsavedChangesModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmUnsavedChangesModal = memo(
  ({ isOpen, onConfirm, onCancel }: IConfirmUnsavedChangesModalProps) => {
    const { handleCloseModal, handleCancelModal, handleConfirm } = useConfirmUnsavedChangesModal({
      isOpen,
      onConfirm,
      onCancel,
    });

    // RENDER
    return (
      <Modal
        isOpen={isOpen}
        lockBodyScroll
        onClose={handleCloseModal}
        isCloseOutside={false}
        className="md:w-[430px] w-[345px] p-[32px]"
      >
        <ModalHeader>
          <ModalTitle>Discard Changes?</ModalTitle>
        </ModalHeader>
        <ModalContent>
          <div className="grid gap-[4px]">
            <Banner className="my-[8px]" icon={TriangleAlert} title={BANNER_TITLE} variant="warning" />
            <div className="text-[14px] font-normal text-[#9D9D9C]">{DESCRIPTION}</div>
          </div>
        </ModalContent>
        <ModalFooter>
          <ModalCloseButton
            onClick={(e) => {
              handleDomBubbleEvent(e);
              handleCancelModal();
            }}
          >
            Cancel
          </ModalCloseButton>
          <ModalConfirmButton
            onClick={(e) => {
              handleDomBubbleEvent(e);
              handleConfirm();
            }}
          >
            Discard Changes
          </ModalConfirmButton>
        </ModalFooter>
      </Modal>
    );
  }
);
ConfirmUnsavedChangesModal.displayName = 'ConfirmUnsavedChangesModal';
export default ConfirmUnsavedChangesModal;
